<template>
  <!-- <div
    v-if="visitBookingEnabled"
    v-resize="setContentHeight"
    :class="[
      { 'inset-box-shadow': !isMobileOrStandaloneMode },
      onsiteMode ? 'bg-blue-radial' : 'bg-teal-radial',
    ]"
  > -->
  <div
    v-if="visitBookingEnabled"
    v-resize="setContentHeight"
    :class="[
      { 'inset-box-shadow': !isMobileOrStandaloneMode },
      onsiteMode ? 'bg-blue-dark' : 'bg-blue-dark',
    ]"
  >
    <!-- Toolbar -->
    <v-toolbar dark color="transparent" class="pr-1">
      <v-btn icon @click="$router.push('/', () => {})" style="z-index: 1">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>Login</v-toolbar-title>
    </v-toolbar>

    <div ref="loginOptionsScrollable" class="scrollable box-shadow-inset">
      <v-card
        color="transparent"
        style="height: inherit"
        class="white--text flex-center-container"
        elevation="24"
      >
        <div>
          <div class="text-large text-center pb-8">Log in with</div>
          <div>
            <v-container>
              <v-row class="no-gutters">
                <v-col class="flex-center-container">
                  <v-btn
                    dark
                    large
                    color="orange darken-2"
                    class="px-5 text-none"
                    style="border-radius: 20px"
                    width="150"
                    height="130"
                    @click="navigateToMyLibraryUsernameLogin"
                  >
                    <div>
                      <div class="mb-2">
                        <v-icon x-large dark>mdi-library</v-icon>
                      </div>
                      <div class="text-medium white--text">
                        myLibrary<br />username
                      </div>
                    </div>
                  </v-btn>
                  <div class="px-4 mt-4 text-center white--text">
                    To book library seats & visits
                  </div>
                </v-col>
                <v-col class="flex-center-container">
                  <v-btn
                    dark
                    large
                    color="orange darken-2"
                    class="px-5 text-capitalize"
                    style="border-radius: 20px"
                    width="150"
                    height="130"
                    @click="navigateToEmailMobileLogin"
                  >
                    <div>
                      <div class="mb-5">
                        <v-icon dark x-large class="pr-1">mdi-cellphone</v-icon>
                        <v-icon dark x-large>mdi-email</v-icon>
                      </div>
                      <div class="text-medium white--text">Mobile/Email</div>
                    </div>
                  </v-btn>
                  <div class="px-4 mt-4 text-center white--text">
                    To book library visits only
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apiHelper from "@/helpers/apiHelper";

export default {
  name: "LoginOptions",
  methods: {
    navigateToMyLibraryUsernameLogin() {
      apiHelper.casAuth();
    },
    navigateToEmailMobileLogin() {
      this.$router.push({
        name: "EmailMobileLogin",
        query: { from: 'loginOptions' },
      });
    },
    setContentHeight() {
      if (this.$refs.loginOptionsScrollable) {
        const heights = this.heights();
        const contentHeight = heights.screen - heights.toolbar - heights.noticeBarHeight;

        this.$refs.loginOptionsScrollable.style.height = contentHeight + "px";
      }
    },
  },
    computed: {
      ...mapGetters(["visitBookingEnabled"]),
  },
  activated() {
    this.$nextTick(() => this.setContentHeight());
    // if (this.authenticated) {
    //   this.$router.push({ name: "Home" });
    // }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.authenticated) {
        return next({ name: "Home" });
      } else {
        if (vm.visitBookingEnabled) {
          next();
        } else {
          apiHelper.casAuth();
        }
      }
    });
  },
};
</script>
